import {useState, useEffect, useRef} from 'react'
import { useAppContext } from './../Context';
import { Link } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';

//import translation
import { useTranslation } from "react-i18next";
import "../../i18n";

// import tags
import {
    Image,
    Row,
    Col,
    Tab,
    Tabs,
    Button
} from 'react-bootstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {faGoogle} from '@fortawesome/free-brands-svg-icons';

// import resources

import LoginBg from '../../assets/image/login.jpg'
import registerBg from '../../assets/image/register.jpg'

// api

import {auth, register} from '../../api/Api'

function Auth(props) {

    //get locale
    const { t } = useTranslation();


    const { login } = useAppContext();

    //login
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [user, setUser] = useState(null);
    const [googleUser, setGoogleUser] = useState(null);
    
    //register
    const [regFname, setRegFname] = useState('');
    const [regLname, setRegLname] = useState('');
    const [regEmail, setRegEmail] = useState('');
    const [regPassword, setRegPassword] = useState('');
    const [regRepeatPassword, setRegRepeatPassword] = useState('');
    const [response, setResponse] = useState(null);
    const [loading, setLoadgin] = useState(false);
    const [googleLoading, setGoogleLoading] = useState(false)

    //message
    const [message, setMessage] = useState(false);
    const [regMessage, setRegMessage] = useState(false);

    //validate login messages
    const [emailMessage, setEmailMessage] = useState(false);
    const [passwordMessage, setPasswordMessage] = useState(false);

    //validate register messages
    const [fnameMessage, setFnameMessage] = useState(false);
    const [lnameMessage, setLnameMessage] = useState(false);
    const [emailRegisterMessage, setEmailRegisterMessage] = useState(false);
    const [passwordRegisterMessage, setPasswordRegisterMessage] = useState(false);
    const [repeatPasswordMessage, setRepeatPassword] = useState(false);

    const registerTabRef = useRef(null);

    const handleClick = () => {
        if (registerTabRef.current) {
        registerTabRef.current.click();
        }
    };

    function validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    

    useEffect(() => {
        if (user !== null) {
            if (user && user.isSuccess === true) {
                localStorage.setItem('token', user.token);
                login();
                props.setAuthModal(false);
            } else {
                setMessage(t('user_or_pass_is_incorrect'));
            }
        }

        setLoadgin(false);
        setGoogleLoading(false);

    }, [user]);

    const handleLogin = async () => {

        let isValid = true;

        if(email === "") {
            setEmailMessage(t('enter_email'));
            isValid = false;
        } else if(!validateEmail(email)) {
            setEmailMessage(t('email_format_error'));
            isValid = false;
        } else {
            setEmailMessage(false);
        }

    
        if(password === "") {
            setPasswordMessage(t('enter_password'));
            isValid = false;
        } else {
            setPasswordMessage(false);
        }

        if(isValid == false) {
            setMessage(false);
            return false;
        }

        setLoadgin(true);

        const data = {
            'email': email,
            'password': password
        };
    
        await auth(setUser, data);
    };


    useEffect(() => {
        if (response !== null) {
            if(response?.status == 'success') {
                alert(response.reason);
                props.setAuthModal(false);
            } else {
                setRegMessage(response.reason);
            }
        }
        setLoadgin(false);
    }, [response]);


    const handleRegister = async () => {
        
        let isValid = true;

        if(regFname === "") {
            setFnameMessage(t('enter_fname'));
            isValid = false;
        } else {
            setFnameMessage(false);
        }

        if(regLname === "") {
            setLnameMessage(t('enter_lname'));
            isValid = false;
        } else {
            setLnameMessage(false);
        }

        if(regEmail === "") {
            setEmailRegisterMessage(t('enter_email'));
            isValid = false;
        } else if(!validateEmail(regEmail)) {
            setEmailRegisterMessage(t('email_format_error'));
            isValid = false;
        } else {
            setEmailRegisterMessage(false);
        }

    
        if(regPassword === "") {
            setPasswordRegisterMessage(t('enter_password'));
            isValid = false;
        } else {
            setPasswordRegisterMessage(false);
        }

        if(regRepeatPassword === "") {
            setRepeatPassword(t('repeat_password'));
            isValid = false;
        } else {
            setRepeatPassword(false);
        }


        

        if(isValid == false) {
            setMessage(false);
            return false;
        }

        setLoadgin(true);

        if(regPassword == regRepeatPassword) {
            const data = {
                'fname': regFname,
                'lname': regLname,
                'email': regEmail,
                'password': regPassword
            }

            await register(setResponse, data);

        } else {
            setRegMessage(t('password_not_match'))
        }

    };


    const googleLogin = useGoogleLogin({
        onSuccess: async tokenResponse => {
          try {
            const { access_token } = tokenResponse;
    
            const response = await axios.get(
              'https://www.googleapis.com/oauth2/v3/userinfo',
              { headers: { Authorization: `Bearer ${access_token}` } }
            );
    
            setGoogleUser(response.data);
            
          } catch (error) {
            console.error('Failed to fetch user info:', error);
          }
        },
        onError: error => {
          console.log('Login failed:', error);
        },
        scope: 'openid email profile', 
    });


    useEffect(()=> {
        
        if(googleUser !== null) {
            setGoogleLoading(true);
            const data = {
                'email': googleUser.email,
                'google_id': googleUser.sub,
                'given_name': googleUser.given_name,
                'family_name': googleUser.family_name
            };
        
            auth(setUser, data);
        }
    }, [googleUser]);
    

    return (
        <div className="authContainer">
            <div className="closeAuthModal"
                onClick={
                    () => props.setAuthModal(false)
            }>
                <FontAwesomeIcon icon={faTimes}/>
            </div>
            <Tabs defaultActiveKey="auth" id="uncontrolled-tab-example" className="mb-3">
                <Tab eventKey="auth" title={<span>{t('log_In')}</span>}>
                    <Row>
                        <Col xl={6}>
                            <Image className='w-100'
                                src={LoginBg}/>
                        </Col>
                        <Col xl={6}>
                            <h4 className='loginTitle'>{t('log_In')}</h4>
                            { googleLoading ? 
                                
                                <div>
                                    <a className='googleAuth'>
                                        <FontAwesomeIcon icon={faGoogle}/>
                                        <span>
                                            <BeatLoader
                                                color='red'
                                                size={10}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </span>
                                    </a>
                                </div>
                            : 
                                <div>
                                    <a className='googleAuth' onClick={() => googleLogin()}>
                                        <FontAwesomeIcon icon={faGoogle}/>
                                        <span>{t('lognWithGoolge')}</span>
                                    </a>
                                </div>
                            }
                            
                            <div className='position-relative'>
                                <hr className='orAuth'/>
                            </div>
                            <div className="awd">
                                <div className="message badge text-danger mb-2 px-0">{ message }</div>
                                <div className='form-group mb-3'>
                                    <input className='form-control h52' type='text' placeholder={t('email')}
                                        value={email}
                                        onInput={
                                            (event) => setEmail(event.target.value)
                                        }/>
                                    
                                    { emailMessage ? <p className="errorMessage text-danger">{emailMessage}</p> : '' }
                                </div>
                                <div className='form-group'>
                                    <input className='form-control h52' type={showPassword ? 'text' : 'password'} placeholder={t('password')}
                                        value={password}
                                        onInput={
                                            (event) => setPassword(event.target.value)
                                        }/>
                                        <span
                                            className="position-absolute end-0 top-50 translate-middle-y pe-3 pswShow"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? '🙈' : '👁️'}
                                        </span>
                                    
                                    { passwordMessage ? <p className="errorMessage text-danger">{passwordMessage}</p> : '' }
                                </div>
                                <div className='authAdditionalOptions mt-5 mb-3'>
                                    <div className='position-relative'></div>
                                    <a className="forgot" href="#">{t('forgotPassword')}</a>
                                </div>
                                <div>
                                    
                                </div>
                                { loading ? 
                                    <Button variant='success' className='w-100 h52'>
                                        <BeatLoader
                                            color='#fff'
                                            size={10}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                        />
                                    </Button>
                                : 
                                    <Button variant='success' className='w-100 h52' onClick={handleLogin}>
                                        {t('log_In')}
                                    </Button>
                                }
                            </div>
                            <div className='suggestRegister'>
                                {t('dontHaveAccount')}
                                <strong onClick={handleClick} className='ms-2'>
                                    {t('register')}
                                </strong>

                            </div>
                        </Col>
                    </Row>


                </Tab>
                <Tab eventKey="register" title={<span ref={registerTabRef}>{t('register')}</span>}>
                    <Row>
                        <Col xl={6}>
                            <Image className='w-100'
                                src={registerBg}/>
                        </Col>
                        <Col xl={6}>
                            <h4 className='loginTitle'>{t('register')}</h4>
                            { googleLoading ? 
                                
                                <div>
                                    <a className='googleAuth'>
                                        <FontAwesomeIcon icon={faGoogle}/>
                                        <span>
                                            <BeatLoader
                                                color='red'
                                                size={10}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </span>
                                    </a>
                                </div>
                            : 
                                <div>
                                    <a className='googleAuth' onClick={() => googleLogin()}>
                                        <FontAwesomeIcon icon={faGoogle}/>
                                        <span>{t('lognWithGoolge')}</span>
                                    </a>
                                </div>
                            }
                            <div className='position-relative'>
                                <hr className='orAuth'/>
                            </div>


                            <div className="awd">
                                <div className="message badge text-danger mb-2 px-0">{ regMessage }</div>
                                <div className='form-group mb-3'>
                                    <input className='form-control h52' value={regFname} onInput={(event) => setRegFname(event.target.value)} type='text' placeholder={t('fname')} />
                                    { fnameMessage ? <p className="errorMessage text-danger">{fnameMessage}</p> : '' }
                                </div>
                                <div className='form-group mb-3'>
                                    <input className='form-control h52' value={regLname} onInput={(event) => setRegLname(event.target.value)} type='text' placeholder={t('lname')} />
                                    { lnameMessage ? <p className="errorMessage text-danger">{lnameMessage}</p> : '' }
                                </div>
                                <div className='form-group mb-3'>
                                    <input className='form-control h52' value={regEmail} onInput={(event) => setRegEmail(event.target.value)} type='text' placeholder={t('email')} />
                                    { emailRegisterMessage ? <p className="errorMessage text-danger">{emailRegisterMessage}</p> : '' }
                                </div>
                                <div className='form-group mb-3'>
                                    <input className='form-control h52' value={regPassword} onInput={(event) => setRegPassword(event.target.value)} type='password' placeholder={t('password')} />
                                    { passwordRegisterMessage ? <p className="errorMessage text-danger">{passwordRegisterMessage}</p> : '' }
                                </div>
                                <div className='form-group mb-3'>
                                    <input className='form-control h52' value={regRepeatPassword} onInput={(event) => setRegRepeatPassword(event.target.value)} type='password' placeholder={t('repeat_password')} />
                                    { repeatPasswordMessage ? <p className="errorMessage text-danger">{repeatPasswordMessage}</p> : '' }
                                </div>
                                
                                <div className='authAdditionalOptions mt-4 mb-3'>
                                    <div className='position-relative'>
                                        <input type="checkbox" className="custom-control-input" id="exampleCheck2"/>
                                        <label className="custom-control-label" htmlFor="exampleCheck2">{t('agree_site')} <Link to="/">{t('agree_terms')}</Link></label>
                                    </div>
                                </div>

                                    { loading ? 
                                        <Button variant='success' className='w-100 h52'>
                                            <BeatLoader
                                                color='#fff'
                                                size={10}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </Button>
                                    : 
                                        <Button variant='success' className='w-100 h52' onClick={handleRegister}>
                                            {t('register')}
                                        </Button>
                                    }

                            </div>
                        </Col>
                    </Row>
                </Tab>
            </Tabs>
        </div>
    )

}

export default Auth;
